// popup on the result page
const popup_close = document.querySelectorAll('[data-popup-close]') || null;
if(popup_close){
    popup_close.forEach(b => {
    b.addEventListener("click", (event) => {
      event.preventDefault();       
      const main_popup = event.target.closest('[data-poup]') || null;      
         if(!main_popup) return;
         main_popup.classList.remove("open"); 
         document.body.classList.remove("popup_open");                     
      });
   });
} 

const popup_open = document.querySelectorAll('[data-popup-open]') || null;
  if(popup_open){
      popup_open.forEach(b => {
      b.addEventListener("click", (event) => {        
        event.preventDefault();
           const main_popup = document.querySelector(event.target.hash) || null;     
          if(!main_popup) return;          
            main_popup.classList.add("open"); 
            document.body.classList.add("popup_open");
        });
     });
  }  

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();
  Addresualtpageimage();
})();


// metafield result data store
const download_pdf = document.querySelector("#save_confi_data");
download_pdf?.addEventListener('click', function (btn) {    
  const file_data = localStorage.getItem("finalData") || null;
  document.body.classList.remove("pdf-mode");
  document.body.classList.add("pdf-mode");
  if(!file_data){
    document.body.classList.remove("pdf-mode");
    return;
  }   
  const finalData = JSON.parse(localStorage.getItem("finalData")) || {};
  async function saveFormData(uploadKey) {          
    const result_save = await people_data_upload_meta(finalData, uploadKey);
    if(result_save){
      document.body.classList.remove("pdf-mode");
      // localStorage.removeItem("finalData");
    }
  } 
  
  if (document.body.classList.contains("template-xs-result")) {
    saveFormData("configurators_scadas_xs_from_data_meta");
  } else if (document.body.classList.contains("template-result-scadas-testsystem")) {
    saveFormData("configurators_scadas_from_data");
  } else if(document.body.classList.contains("template-mobile-result")){
    saveFormData("configurators_mobile_from_data");    
  } else if(document.body.classList.contains("template-t3ster-result")){
    saveFormData("configurators_t3ster_from_data"); 
  }else if(document.body.classList.contains("template-rs-result")){
    saveFormData("configurators_scadas_rs_from_data");    
  }else if(document.body.classList.contains("template-es-result")){
    saveFormData("configurators_scadas_es");    
  }else if(document.body.classList.contains("template-anovis-plan-result")){
    saveFormData("configurators_anovis_plan");    
  } else if (document.body.classList.contains("template-star_ccm")){
    saveFormData("configurators_scadas_star_ccm_from_data_meta");    
  }else if (document.body.classList.contains("template-amesim")){       
    saveFormData("configurators_scadas_amesim_from_data_meta"); 
  }else if (document.body.classList.contains("template-bedarfsermittlernew")){       
    saveFormData("configurators_scadas_bedarfsermittlernew_from_data_meta"); 
  } else if(document.body.classList.contains("template-simcenter-3d")) {
    saveFormData("configurators_scadas_simcenter_3d_from_data_meta");  
  } else if(document.body.classList.contains("template-testlab")) {    
    saveFormData("configurators_scadas_testlab_from_data_meta");  
  } else if(document.body.classList.contains("template-credit-requirement-assess")) {    
    saveFormData("configurators_credit_requirements_from_data_meta");  
  }

  // metafield in result data set end 
});             


// register page table hide/show (FIXED)
const tableTitles = document.querySelectorAll(".table-regi");

tableTitles.forEach((btn) => {
  btn.addEventListener("click", function () {
console.log("button clicked");
    // header j jena andar button che
    const header = btn.closest(".header_wrapp");

    // ena immediately pachi aavti table
    const table = header.nextElementSibling;
    if (!table || !table.classList.contains("table")) return;

    const readMore = header.querySelector(".read_more");
    const readLess = header.querySelector(".read_less");

    table.classList.toggle("hidden");

    if (table.classList.contains("hidden")) {      
      readMore?.classList.remove("hidden");
      readLess?.classList.add("hidden");
    } else {      
      readMore?.classList.add("hidden");
      readLess?.classList.remove("hidden");
    }
  });
});


// collection page filter 
  const open_filter_click = document.querySelector('.open_filter');
  if (open_filter_click) {
    open_filter_click.addEventListener('click', function() {
      this.classList.toggle('filter_active');
      document.getElementById('FacetsWrapperDesktop').classList.toggle('dd_cm_filter');
      document.querySelector('[aria-labelledby="verticalTitle"]').classList.toggle('dd_filter');
    });
  }

// pdp tab 
  const tabs_pdp = document.querySelectorAll('[data-tab-target]')
  const tabContents_pdp = document.querySelectorAll('[data-tab-content]')
  
    tabs_pdp?.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = document.querySelector(tab.dataset.tabTarget)
        tabContents_pdp?.forEach(tabContent => {
          tabContent.classList.remove('active');
          tabContent.classList.add('hidden');
        });
        tabs_pdp.forEach(tab => {
          tab.classList.remove('active')         
        });
        tab.classList.add('active')
        target.classList.add('active')
        target.classList.remove('hidden');
      });
    });
   
  const sliders = document.querySelectorAll(".custom-range");  
  sliders?.forEach(slider => {
    function updateBackground() {
      const min = slider.min;
      const max = slider.max;
      const val = slider.value;
      const percentage = ((val - min) / (max - min)) * 100;
      slider.style.background = `linear-gradient(to right, #1593D7 ${percentage}%, #e0e0e0 ${percentage}%)`;
    }
      
    updateBackground();    
    slider.addEventListener("input", updateBackground);
  });

// number show in click of credit button
const acc_summaryBtn_all = document.querySelectorAll(".summary_credit_input");
acc_summaryBtn_all?.forEach(input => {
  input?.addEventListener("change", function () {                     
    const wrapper = input?.closest(".checkbox-accordion");       
    const all_inputs = wrapper?.querySelectorAll(".child_parent");
    const no_selecetd = wrapper?.querySelector(".no_input_accordion");
     
     const checkedInputs = Array.from(all_inputs).filter(input => input.checked);
     if (input.closest(".content_nested_acc") && no_selecetd) {                   
       no_selecetd.innerHTML = checkedInputs.length;
     }
  });
});
  



function openLink(event, btn) {
  event.preventDefault();
  const savedPDF = localStorage.getItem("saved_pdf");
  if(savedPDF){
     const link = document.createElement("a");
        link.href = savedPDF;
        link.target = "_blank";
        link.download = "design-preview.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  }
}


function ZIPdownlod(event,btn) {
   event.preventDefault();
   let Zipfile = localStorage.getItem("ZipFile");
  console.log("Zipfile (raw)", Zipfile);

  if (Zipfile) {
    Zipfile = JSON.parse(Zipfile); 
    const link = document.createElement("a");
    link.href = Zipfile;
    link.download = ""; // keeps original filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}


function Addresualtpageimage(){
 const resultiimage =  document.querySelector('[data-result-page-main-image]') || null;
  let imagesrc = localStorage.getItem("mainconfiimage") || null;
  //  localStorage.removeItem('mainconfiimage');
   if(resultiimage && imagesrc){

    const wrapper = document.createElement("div");
          wrapper.className = "selected_product_show";

          wrapper.innerHTML = `
            <div class="image">
              <img src="${imagesrc}" 
                  alt="product-image-canvas" 
                  loading="lazy" />
            </div>
          `;   

          resultiimage.appendChild(wrapper);
   }
}



function editForm(btn) {
  const editForm_class = btn.closest('.custom-meta-popup');
  if(editForm_class){

    editForm_class.classList.add('active');
  }

}

// lagunage selector 

document.addEventListener("DOMContentLoaded", function () {
  const languageContainers = document.querySelectorAll(".language.custom-lag");

  languageContainers.forEach(container => {
    const languageActive = container.querySelector(".language-active");
    const languageList = container.querySelector(".language-list");

    if (!languageActive || !languageList) return;

    languageActive.addEventListener("click", function () {
      console.log("click !!!");
      languageList.classList.toggle("open");
    });
  });
});


const form_cust = document.querySelector(".form-step-cust #ContactForm");
form_cust?.addEventListener("submit", function (event) {
  console.log("this");
  // document.querySelectorAll(".exclude-from-submit").forEach(input => {
  //   input.disabled = true;
  // });
  onSubmitFunction(event, form_cust);
});

async function onSubmitFunction(event, form) {
  event.preventDefault();
  event.stopImmediatePropagation(); // extra safety for Shopify

  const formData = new FormData(form);  
  const data = Object.fromEntries(formData.entries());  
  try {
    
    let response = null;
     if (document.body.classList.contains("template-scadas-xs")) {
        response = await submit_from_PHP_scadasxs(formData);
     }else{
        response = await submit_from_PHP(formData);   
    }
    

    console.log("response",response); 
    response_result = response.result
    if (response_result.return_to && response_result.status) {
        // localStorage.setItem("form_data", JSON.stringify(data)); 
      if(response_result.return_to.includes('#ContactForm')){
        checkUrl();
      }else{
        window.location.href = response_result.return_to; 
      }
    }
  } catch (err) {
    console.error('Submit failed:', err);
  }
}


const static_bars = document.querySelectorAll(".sticky-bar-icon-steps");
static_bars.forEach(static_bar => {
  static_bar?.addEventListener("click", function (bar) {  
    
    document.body.classList.toggle('hide_progress_bar')
    // const bar_main = static_bar.closest(".cust-form-wrapp.product_step.sticky");    
    // if(bar_main) bar_main.style.display="none";
  });
});

function storeData(){         
  // metafield in result data set
  const selectedProducts = JSON.parse(localStorage.getItem("selectedProducts") || "[]");
  const accordian_info = JSON.parse(localStorage.getItem("accordian_info") || "[]");
  const credit_accordion = JSON.parse(localStorage.getItem("credit_accordion") || "[]");
  const show_image_main = JSON.parse(localStorage.getItem("show_image_main") || "[]");
  const fifth_accordian_info = JSON.parse(localStorage.getItem("fifth_accordian_info") || "[]");
  const seventh_tab_info = JSON.parse(localStorage.getItem("seventh_tab_info") || "[]");
  const ZipFile = JSON.parse(localStorage.getItem("ZipFile") || "[]"); 
  const form_data_ = JSON.parse(localStorage.getItem("form_data") || "[]"); 
 
  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const date_formate = today.toLocaleDateString().replaceAll("/", ".");;
  const body = document.body;                
  console.log("form_data....",form_data_);

  
  const form_data = {};  
      Object.entries(form_data_).forEach(([key, value]) => {            
         form_data[key] = value;                
      });  
      console.log("form_data",form_data);
    // if(document.body.classList.contains("customer-logged-in")){
    const existingData = {};              
        existingData[`Result-${date_formate}`] =  {
            selectedProducts,
            accordian_info,
            credit_accordion,
            show_image_main,
            fifth_accordian_info,
            seventh_tab_info,
            ZipFile,
            form_data
          }            
          // existingData[`form_data`] = {form_data}
          window.finalData = existingData || {};                       
      localStorage.setItem("finalData", JSON.stringify(window.finalData));

      // removeLocalStorage();
      console.log("out side the final Daata",window.finalData);        
}


  function removeLocalStorage(){
      localStorage.removeItem('selectedProducts');
      localStorage.removeItem('accordian_info');
      localStorage.removeItem('credit_accordion');
      localStorage.removeItem('show_image_main');
      localStorage.removeItem('fifth_accordian_info');
      localStorage.removeItem('seventh_tab_info'); 
      localStorage.removeItem("credit_accordion_title");
      localStorage.removeItem("radio_btn_data");
       const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('gclid')) {
     window.history.replaceState({}, '', window.location.href.split('?')[0])

      window.history.replaceState({}, '', window.location.href.split('?')[0]); 
      }
  }

  if (!window.location.hash.includes('#loginmsg')) {
    removeLocalStorage();
  }



    
//================================== comman js for all confi ===========================================================//

// credit step 5 
function preselectedCheckboxMain(allSummary){   
  const preSelected = document.querySelector(".summary_credit_input.main_credit_pre_selected");  
  console.log("preSelected",preSelected)
  const elements = allSummary instanceof NodeList || Array.isArray(allSummary)? [...allSummary]: allSummary? [allSummary]: [];  
  const otherChecked = elements.some(el =>
    !el.classList.contains("main_credit_pre_selected") &&
    !el.classList.contains("child_parent") &&
    el.checked
  );  

  // preSelected.forEach(el => {
    const main_pre_credit = document.querySelectorAll('.main_credit_pre_selected');    
    if (otherChecked) { 
      main_pre_credit.forEach(el => {
        el.disabled = false;         
      });
      // el.click();            
    } else {
      const alreadyChecked = [...main_pre_credit].every(el => el.checked);
      main_pre_credit.forEach(el => {      
        if (!alreadyChecked) {           
          el.click();
          el.disabled = true;
        } else{
          el.disabled = false;          
        } 
      });
    }
  // }); 
}

function preselectedCheckboxChild(allSummary){  
 const preSelected = document.querySelector(".summary_credit_input.pre_credit_selected");  
 if(!preSelected) return;
 const elements = allSummary instanceof NodeList || Array.isArray(allSummary)? [...allSummary]: allSummary? [allSummary]: [];
  // console.log("elements child",elements);

 const otherChecked = [...elements].some(el =>
   !el.classList.contains("pre_credit_selected") &&
   !el.classList.contains("main_collapsible_inp") &&
   el.checked
 );
  const main_pre_credit = document.querySelectorAll('.pre_credit_selected');
 if (!otherChecked){   
   const alreadyChecked = [...main_pre_credit].every(el => el.checked);
   if (!alreadyChecked) { 
    main_pre_credit.forEach(el => {
      el.click()
      el.classList.add("pre_selected_disable");
      // el.disabled = true;
    });
  }
 }else {
    //  preSelected.disabled = false; 
     preSelected.classList.remove("pre_selected_disable");
   }


  //  preSelected.forEach(el => {
  //    if (!otherChecked) {
      
  //     console.log('otherChecked_el',el);
  //    el.click();          
  //      el.disabled = true;  
  //    } else {
  //      el.disabled = false; 
  //    }
  //  }); 
}

function summaryCheckboxAddLoac(){
    // credit step 1 in accordion and also xs step 5 page result 
    const acc_summaryBtn = document.querySelectorAll(".summary_credit_input");
    // const acc_show_credit = document.querySelector(".credit_accordion_result");
    // if(acc_show_credit){acc_show_credit.innerHTML = ""; }
    // localStorage.removeItem('credit_accordion');

    acc_summaryBtn?.forEach((input, index) => {
      input.setAttribute("indexno",index);
      input?.addEventListener("change", function () {               
        const credit_input = input.closest("#collapsible-tab")?.querySelector(".summary_credit_input");         
        const wrapper = input?.closest(".checkbox-accordion");      
        const acc_title = input?.value;    
        const slider_qty = input.closest(".checkbox-accordion");
        const is_child = input.classList.contains("child_parent");
        const is_licence = input.classList.contains("licence-accordion-list");
        // console.log("slider_qty",slider_qty);        
        const acc_content = wrapper?.querySelector(".content_coll p")?.innerHTML;
        const all_inputs = wrapper?.querySelectorAll(".child_parent");
        const no_selecetd = wrapper?.querySelector(".no_input_accordion");
        console.log("credit_input",credit_input)
        // Now count only actually checked inputs
        const checkedInputs = Array.from(all_inputs).filter(input => input.checked);      
        if (input.closest(".content_nested_acc") && no_selecetd) {                   
          no_selecetd.innerHTML = checkedInputs.length;
        }

        if(is_child){
          const childCheckboxes = input?.closest('.accordion')?.querySelectorAll('input.licence-accordion-list');
          console.log("input?.closest('.accordion')",input?.closest('.accordion'));
          const slider_range = input?.closest('.accordion')?.querySelector('input#single_range')?.value;
         
          const anyChecked = [...childCheckboxes].some(cb => cb.checked);
          childCheckboxes.forEach(childCheckbox => {
            if(!anyChecked) childCheckbox.checked = input.checked;
          });

          preselectedCheckboxChild(acc_summaryBtn); 
        } else if(is_licence){          
          const childCheckboxes = input?.closest('.summary_credit')?.querySelector('.child_parent'); 
          const no_selecetd = input?.closest('.checkbox-accordion')?.querySelector('.no_input_accordion'); 
          //  childCheckboxes.checked = input.checked;
          const childCheckboxes_ = childCheckboxes.closest('details').querySelectorAll('input[type="checkbox"].licence-accordion-list');
            const checkedInputs = Array.from(childCheckboxes_).filter(input => input.checked);
            if(checkedInputs.length > 0){
              childCheckboxes.checked = true;
            }else{
              childCheckboxes.checked = false;
            }

            const main_sub_checkbox = input?.closest('.checkbox-accordion')?.querySelectorAll('.child_parent');
            const checkedInputs_ = Array.from(main_sub_checkbox).filter(input => input.checked);
            if(checkedInputs_.length > 0){
              no_selecetd.innerHTML = checkedInputs_.length;
            }else{
              no_selecetd.innerHTML = checkedInputs_.length;
            }
                    
            // childCheckboxes.checked = input.checked;  
            if (childCheckboxes.checked !== input.checked) {
              console.log("childCheckboxes",childCheckboxes);
              childCheckboxes.click();
            }
        }        
        // Select child checkboxes when parent is selected
        // const child_checkboxes = input.closest(".summary_credit")
        //   ?.querySelectorAll(".credit_product");
    
        // if (child_checkboxes && input.checked) {
        //   child_checkboxes.forEach(child => child.checked = true);
        // }

        if (!acc_title && !acc_content) return;
        let storedData = JSON.parse(localStorage.getItem("credit_accordion") || "[]");      
        if (input.checked) {
          const parentElement = input.closest(".show_hidden_content");  
          const parent_sub_acc = input.closest(".summary_credit");                  
          const qty = parent_sub_acc?.querySelector(".slider.custom-range")?.value;
          // console.log("qty",qty);
          if (parentElement) {
            const parentHeadingAcc = parentElement.getAttribute("data-heading-acc");
            const existingTitleIndex = storedData.findIndex(item => item.acc_title === parentHeadingAcc);                                                     
              if (existingTitleIndex !== -1) {
                console.log("existingTitleIndex",existingTitleIndex);              
                const existingTitle = storedData[existingTitleIndex];              
                if (!existingTitle.subObjects) {existingTitle.subObjects = [];}
  
                const alreadyExists = existingTitle.subObjects.some(
                  subItem => subItem.acc_title === acc_title
                );
                if (!alreadyExists) {
                  if (!existingTitle.subObjects.some(subItem => subItem.acc_content === acc_content)) {
                      existingTitle.subObjects.push({ acc_title, qty });                  
                      localStorage.setItem("credit_accordion", JSON.stringify(storedData));                    
                  }
                 }
            } else {   
              console.log("storedData",storedData);         
                storedData.push({
                  key: index,
                  acc_title: parentHeadingAcc,
                  subObjects: [{ acc_title, qty }]
                });           
              localStorage.setItem("credit_accordion", JSON.stringify(storedData));              
            }
          }else{
            console.log("else",storedData,"acc_content",acc_content);

            if (!storedData.some(item => item.acc_content === acc_content)) {
                storedData.push({ index, acc_title, acc_content }); 
                // storedData.push({
                //   index,
                //   acc_title,
                //   acc_content,
                //   subObjects: [{ acc_title }]
                // });
                // is_selected_any_product(input);
              
              // if (acc_show_credit) {
              //   const titleDiv = document.createElement("div");
              //   titleDiv.className = `show_credit_title`;
              //   titleDiv.dataset.title = acc_title; 
              //   titleDiv.innerHTML = acc_title;
      
              //   const contentDiv = document.createElement("div");
              //   contentDiv.className = `show_credit_content`;
              //   contentDiv.dataset.title = acc_title; 
              //   contentDiv.innerHTML = acc_content;
      
              //   acc_show_credit.appendChild(titleDiv);
              //   acc_show_credit.appendChild(contentDiv);
              // }
              //   }
              // } else {        
              //   // Remove unchecked item from storage
                // storedData = storedData.filter(item => item.acc_title !== acc_title);
              //   // Remove the corresponding HTML elements
              //   if (acc_show_credit) {
              //     const titleDiv = acc_show_credit.querySelector(`.show_credit_title[data-title="${acc_title}"]`);
              //     const contentDiv = acc_show_credit.querySelector(`.show_credit_content[data-title="${acc_title}"]`);
              //     if (titleDiv) titleDiv.remove();
              //     if (contentDiv) contentDiv.remove();                           
                // is_selected_any_product(input);                           
            }
          }       
        }else{        
          storedData = storedData.filter(item => item.acc_title !== acc_title);          
          storedData.forEach(item => {
            if (item.subObjects && Array.isArray(item.subObjects)) {
              item.subObjects = item.subObjects.filter(
                subItem => subItem.acc_title !== acc_title
              );
            }
          });         
          // isalready_selected_any_product(input);
        }
        localStorage.setItem("credit_accordion", JSON.stringify(storedData)); 
        // console.log("insdie the forr...")
        preselectedCheckboxMain(acc_summaryBtn);            
      });
    });

  // console.log("out side the for...")
     preselectedCheckboxMain(acc_summaryBtn);
      preselectedCheckboxChild(acc_summaryBtn);

    // const parentCheckboxes = document.querySelectorAll('.summary_credit_input.child_parent');    
    // parentCheckboxes?.forEach(parentCheckbox => {
    //   parentCheckbox?.addEventListener('change', function () {  
    //     console.log("parentCheckbox",parentCheckbox);
    //     const childCheckboxes = parentCheckbox?.closest('.accordion')?.querySelectorAll('input.licence-accordion-list');
    //     childCheckboxes.forEach(childCheckbox => {
    //       console.log("childCheckbox",childCheckbox);
    //       childCheckbox.checked = parentCheckbox.checked;
    //     });
    //   });
    // });

    const licenceCheckboxes = document.querySelectorAll('input.licence-accordion-list');
    licenceCheckboxes?.forEach(licenceCheckbox => {
      licenceCheckbox?.addEventListener('change', function () {   
        // console.log('change event called..') ;
        const childCheckboxes = licenceCheckbox?.closest('.summary_credit')?.querySelector('.child_parent'); 
        const no_selecetd = licenceCheckbox?.closest('.checkbox-accordion')?.querySelector('.no_input_accordion'); 
        //  childCheckboxes.checked = licenceCheckbox.checked;
        const childCheckboxes_ = childCheckboxes.closest('details').querySelectorAll('input[type="checkbox"].licence-accordion-list');
        const checkedInputs = Array.from(childCheckboxes_).filter(input => input.checked);
          if(checkedInputs.length > 0){
            if(!childCheckboxes.checked){
              console.log("childCheckboxes",childCheckboxes);
              childCheckboxes.click();
              childCheckboxes.checked = true;
            }
          }else{
            // console.log("inside the else");
            childCheckboxes.checked = false;
          }

          const main_sub_checkbox = licenceCheckbox?.closest('.checkbox-accordion')?.querySelectorAll('.child_parent');
          const checkedInputs_ = Array.from(main_sub_checkbox).filter(input => input.checked);
          if(checkedInputs_.length > 0){
            no_selecetd.innerHTML = checkedInputs_.length;
          }else{
            no_selecetd.innerHTML = checkedInputs_.length;
          }
                  // console.log("childCheckboxes.checked",childCheckboxes.checked,"licenceCheckbox.checked",licenceCheckbox.checked);
          // childCheckboxes.checked = licenceCheckbox.checked;  
          if (childCheckboxes.checked !== licenceCheckbox.checked) {
            if(!childCheckboxes.checked){
              console.log("childCheckboxes second",childCheckboxes);
              childCheckboxes.click();
            }
          }
      });      
    });
}

//popup code


  function combineslotpopupopen(This) {    
      if(!This) return;
      const Popup_ = This.querySelector('#combination-popup') || null;
      if(!Popup_) return;
          Popup_.classList.remove('hidden');
          document.body.classList.add('popup-active');
  }


    function combineslotpopuclose(This) {    
      if(!This) return;
      const Popup_ = This.closest('#combination-popup') || null;
      if(!Popup_) return;
          Popup_.classList.add('hidden');
          document.body.classList.remove('popup-active');
  }


function popOpentooltip(btn){
  const parent = btn.closest(".card-hading");  
  parent?.querySelector(".popup_data").classList.remove("hidden");
  document.body.classList.add("tooltippop_open");
}

function popupCloseTooltip(btn){
 const parent = btn.closest(".popup_data");  
  parent?.classList.add("hidden");
  document.body.classList.remove("tooltippop_open");
}

function openpopupselectet(input) {
  const slot_parant = input.closest('.slot') || null;

  if(slot_parant && slot_parant.classList.contains('its-combine') ){
    combineslotpopupopen(input.closest('.selected_product_details'));

    return;
  }

  const input_val = input.value || null;

  if(input_val){
    const popup_button_select = document.querySelector(
    `.main-tab-products-content .card_product_custom .product-card[data-variant-id="${input_val}"] button.cust_show_more_button`
    ) || null;
    // console.log(popup_button_select,"popup_button_select");
    if(popup_button_select) popup_button_select.click();
  }
}

function openpopupproductinfo(This){
  const this_main_popup_con = This.closest('.card_popup_content');
  const this_main_popup = this_main_popup_con.querySelector('[product-info-popup]');
  if(this_main_popup){
    this_main_popup.classList.remove('hidden');
    this_main_popup_con.classList.add('popup-active');
    document.body.classList.add('popup-active');
  }
}

function popupCloseinfo(This){
  const this_main_popup_con = This.closest('.card_popup_content');
  const this_main_popup = this_main_popup_con.querySelector('[product-info-popup]');
  if(this_main_popup){
    this_main_popup.classList.add('hidden');
    this_main_popup_con.classList.remove('popup-active');
    document.body.classList.remove('popup-active');
  }
}

function customSecPopupOpen(This){  
  const this_main_popup_con = This.closest('.card_popup_content');
  const this_main_popup = this_main_popup_con.querySelector('.capacity_popup_data');  
  if(this_main_popup){
    this_main_popup.classList.remove('hidden');
    this_main_popup_con.classList.add('popup-active1');
    document.body.classList.add('popup-active');
  }
}

function customSecPopupClose(This){  
  const this_main_popup_con = This.closest('.card_popup_content');
  const this_main_popup = this_main_popup_con.querySelector('.capacity_popup_data');  
  if(this_main_popup){
    this_main_popup.classList.add('hidden');
    this_main_popup_con.classList.remove('popup-active1');
    document.body.classList.remove('popup-active');
  }
}



function customSecPopupCloseLimit() {
  const popup_parent = document.querySelector("#columan_popup_slot");
  popup_parent.style.display = "none";
  popup_parent.classList.remove("open_popup");
  document.body.classList.remove("limit_popup_open");
}

function remove_itemson(This){ 
 const selected_card = This.closest('.grid__item'); 
 const main_button = selected_card?.querySelector("[data-custom-input-conf]");
 const product_tag = selected_card?.querySelector('.selected_product_tag');
 const qty_inp = selected_card.closest(".grid__item")?.querySelector(".quantity__input");
 const handle_tab = main_button?.getAttribute("data-var-handle");  
 if(!handle_tab) return;  
  
  const details = This.closest(".pro-card-details"); 
  let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];  
  const index = stored.findIndex(item => item.handle === handle_tab); 
    if (index !== -1) stored.splice(index, 1)  
      
    localStorage.setItem("selectedProducts", JSON.stringify(stored));
    localStorage.setItem("resultProduct", JSON.stringify(stored));

    if(product_tag) product_tag.innerHTML = ''
    if(qty_inp)qty_inp.value = 0;  

    const tab = This.closest(".selecetd_product_tab.tab-section"); 
    const first_tab_data = tab?.getAttribute("data-first-collection");
    const second_tab_data = tab?.getAttribute("data-second-collection"); 
      This.remove(); 

      const cards_ = tab?.querySelectorAll('.card_product_custom');          
      let finalResult = true; 
      for (let [index, card] of Array.from(cards_).entries()) {
        const label = card?.querySelector(".selected_product_tag");
        const value = label ? label.innerHTML.trim() : "";
        const isEmpty = value === "";
        if (isEmpty === false) {
          finalResult = false;
          break; 
        }
      }

      if(finalResult){
        if(first_tab_data != null){
          details?.querySelector(".after_sensor")?.classList.remove("active");
          details?.querySelector(".befor_sensor")?.classList.add("active");
        } 
        if(second_tab_data != null){
          details?.querySelector(".after_cabel")?.classList.remove("active");
          details?.querySelector(".befor_cabel")?.classList.add("active");
        }
      }                     
}


async function onchecang_iteams(This,its_pluse,difreans,Event){
  console.log("This",This,"Event",Event);
  const card =  This.closest('.grid__item');
  const main_button = card?.querySelector("[data-custom-input-conf]") || null;
  const handle = main_button?.getAttribute("data-var-handle"); 
  const product_tag = card?.querySelector('.selected_product_tag');
  const product_button = card?.querySelector('.card__content');
  const step_no = get_the_step_no(This);
  const name = This.name;
let parent_section = main_button?.closest(".selected_product_data") || null;
 const pre_selected_product_slot = parent_section?.querySelector(`[data-slot-first-data='${handle}']`) || null;



  // if(document.body.classList.contains('template-scadas-rs') && its_pluse && !pre_selected_product_slot){
  //   document.querySelectorAll(".metawise-selected_rs .grid__item.selected_card").forEach(el => el.classList.remove("selected_card"));
  //                  card.classList.add("selected_card");
  //    rs_popuup_open();
  //   return null;
  // }
                              
                              
 

  const product_tag_label = product_tag?.getAttribute("tag-attr") || "Ausgewählt";   
    if (main_button != null && !main_button?.checked) {
      main_button.checked = true;
    }

  const productTitle = main_button?.dataset.productTitle;
  const quantity =  parseInt(This.value);
  const occcupied_slot = parseInt(This.getAttribute('occcupied_slot')) || 1;
  const variantId = main_button?.value;
  

  if(!parent_section) parent_section = main_button?.closest(".selected_product_data") || null;

  const image_parent = parent_section?.querySelector("[data-product-append-main]");
  const slotInputs = Array.from(document.querySelectorAll(".meta-slot-input")); 
  const main_class = main_button?.closest("metawise-variant-selector") || null;
  const all_added_sload = document.querySelector('.meta-slots')?.querySelectorAll(`[data-meta-handle="${handle}"]`);
  const lastItems = all_added_sload? Array.from(all_added_sload).slice(difreans): [];
  const radios = parent_section?.querySelectorAll(".product-card .variant-checkbox"); 
  let totalQty = 0;
  if(radios){
    totalQty = Array.from(radios)
            .filter(input => !input.value.includes(product_tag_label))
            .reduce((sum, input) => {
              const card = input.closest(".product-card");
              const quantity = parseInt(
                card?.querySelector(".quantity_product_card")?.value || 1,
                10
              );
              return sum + quantity;
            }, 0);
          }else{

             totalQty = quantity;
          }

    console.log("totalQty",totalQty);

    if(!handle) return;
    const selected_card = This.closest('.grid__item');        
    const details = selected_card?.closest(".pro-card-details");
    const tab = This.closest(".selecetd_product_tab.tab-section"); 
    const first_tab_data = tab?.getAttribute("data-first-collection");
    const second_tab_data = tab?.getAttribute("data-second-collection");       
      console.log("first_tab_data",first_tab_data,"tab",tab,"second_tab_data",second_tab_data,"selected_card",selected_card,"details",details);
                   
    This.removeAttribute("disabled");
    let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];  
      const index = stored.findIndex(item => item.handle === handle);       
      if(quantity <= 0){
        if (index !== -1) {
                stored.splice(index, 1);
              }  
            // localStorage.setItem("selectedProducts", JSON.stringify(stored));
            if(product_tag) product_tag.innerHTML = '';
            const button_added_ava = product_button.querySelector('.remove-select') || null;
            if(button_added_ava) button_added_ava.remove();
            lastItems?.forEach((item) => {
                item.querySelector('.remove-second-btn')?.click();
              });

      }else{        
          if (index !== -1) {
              stored[index] = {
                ...stored[index],
                handle,
                name,
                quantity,
                step_no
              };            
          }else{
             stored.push({ handle, name, quantity, step_no });
          }
     
            if(product_tag && product_tag_label){
              product_tag.innerHTML = product_tag_label;
            }

            const button_added_ava = product_button.querySelector('.remove-select') || null;            
              if (!button_added_ava && !This.closest(".fourth_step")){
                var button_added = document.createElement("button");
                // Set attributes
                button_added.type = "button";
                button_added.onclick = function() {
                    remove_itemson(this);
                };
                // Add inner HTML
                button_added.classList.add('remove-select')
                button_added.innerHTML = "<span>remove</span>";
                // Append to body
                product_button.appendChild(button_added);
              }

              if(This.closest(".fourth_step")){  

                console.log("its_pluse_its_pluse",its_pluse);


                if(its_pluse){

                   document.querySelectorAll(".metawise-selected_rs .grid__item.selected_card").forEach(el => el.classList.remove("selected_card"));
                   card.classList.add("selected_card");

                  if (typeof main_class.getNextEmptySlot === "function") {
                    console.log("occcupied_slot",occcupied_slot);
                      if(occcupied_slot ==1){
                        console.log("insdie the iff...");                        
                        // for (let i = 0; i < quantity; i++) {   
                        for (let i = 0; i < difreans; i++) {   
                          let emptySlot = false;  
                            if(document.body.classList.contains('template-scadas-rs')){
                              
                               const pre_selected_product_slot = parent_section.querySelector(`[data-slot-first-data='${handle}']`);                      
                              if(pre_selected_product_slot){
                                if (typeof main_class.getSlotByHandle === "function") { 
                                  emptySlot = main_class.getNextAssignSlotPre(This);                          
                                }
                              }else{                              
                                   emptySlot = main_class.getNextAssignSlot(slotInputs);  
                              }
                            }else{
                              emptySlot = main_class.getNextEmptySlot(slotInputs);
                            }                          
                            
                            console.log("emptySlot",emptySlot);

                          if (!emptySlot) break; 
                            if (typeof main_class.fillSlot === "function") {
                              main_class.fillSlot(i, image_parent, main_button, emptySlot, variantId, handle, productTitle);
                            }
                        }
                      }else{
                        console.log("insdie the else...");
                         let emptySlot = false;
                        if(document.body.classList.contains('template-scadas-rs')){                                                      
                        
                          const pre_selected_product_slot = parent_section.querySelector(`[data-slot-first-data='${handle}']`);                      
                              if(pre_selected_product_slot){
                                if (typeof main_class.getSlotByHandle === "function") { 
                                  emptySlot = main_class.getNextAssignSlotPre(This);                          
                                }
                              }else{                              
                                   emptySlot = main_class.getNextAssignSlot(slotInputs);  
                              }

                        }else{
                          emptySlot = main_class.getNextEmptySlot(slotInputs);
                        }            
                              
                            // if (!emptySlot) return;                  
                          if (typeof main_class.checkQtyButtonState === "function") {
                            main_class.checkQtyButtonState(true, main_button, totalQty, slotInputs);
                          }
                          if (typeof fillSlot_occcupied_slot === "function") {    
                            fillSlot_occcupied_slot(image_parent, main_button, occcupied_slot, variantId, handle, productTitle,1,this);                 
                            // fillSlot_occcupied_slot(image_parent, button, occcupied_slot, variantId, handle, productTitle,quantity,this);
                          }
                      } 
                    }
                }else{
                  

                   if(document.body.classList.contains('template-scadas-rs') && !its_pluse && pre_selected_product_slot){
                         This.closest('.card-information').classList.remove('limet_over'); 
                    }

                  // lastItems?.forEach((item) => {
                      // item.querySelector('.remove-second-btn')?.click();
                    // });
                }


                  //  fillSlot_occcupied_slot(image_parent, main_button, occcupied_slot, variantId, handle, productTitle,1,this);                 
                  // fillSlot_occcupied_slot(image_parent, button, occcupied_slot, variantId, handle, productTitle,quantity,this);
              }

              if(radios){
                console.log("added product in 6 stap");
                 if(!document.body.classList.contains('template-scadas-rs')){
                  slot_select_in_sexth_stap(main_button,slotInputs,totalQty);
                 }
              }
      }

      const cards_ = tab?.querySelectorAll('.card_product_custom');          
      let finalResult = true;       
        let count_tag = 0;
        if(cards_){
          for (let [index, card] of Array.from(cards_).entries()) {        
            const label = card?.querySelector(".selected_product_tag");
            const value = label ? label.innerHTML.trim() : "";        
            const isEmpty = value === "";        
            if (isEmpty === false) {
              // finalResult = false;  
              count_tag ++  ;      
              // break; 
            }
          }   
        }

      if(count_tag <= 0){
        finalResult = false;
      } 

   if(Event.target.name === 'plus'){          
        if(finalResult){
          if(first_tab_data != null){
            details?.querySelector(".after_sensor")?.classList.add("active");
            details?.querySelector(".befor_sensor")?.classList.remove("active");
          } 
          if(second_tab_data != null){
            details?.querySelector(".after_cabel")?.classList.add("active");
            details?.querySelector(".befor_cabel")?.classList.remove("active");
          }
        }    
    }else{      
        if(!finalResult){
          if(first_tab_data != null){
            details?.querySelector(".after_sensor")?.classList.remove("active");
            details?.querySelector(".befor_sensor")?.classList.add("active");            
          } 
          if(second_tab_data != null){
            details?.querySelector(".after_cabel")?.classList.remove("active");
            details?.querySelector(".befor_cabel")?.classList.add("active");            
          }
        }    
    }      

  localStorage.setItem("selectedProducts", JSON.stringify(stored));
  localStorage.setItem("resultProduct", JSON.stringify(stored));
      
}

// fillsloat one images with two input

function getNextEmptySlot(slotInputs) {
  return slotInputs.find(input => !input.checked);
}

function fillSlot_occcupied_slot(parent, selector, occcupied_slot, variantId, handle, productTitle,qty,This,input){  
    const imgSrc = selector.dataset.slotImage;  
    const is_image_meta = selector.dataset.productIsImage;   
    let canvas_groupid  = null;         
    const slotData = [{
      slotTop: selector.dataset.slotTop? Math.round(Number(selector.dataset.slotTop)): null,  
      slotRight: selector.dataset.slotRight? Math.round(Number(selector.dataset.slotRight)): null,    
      slotHeight: selector.dataset.slotHeight? Math.round(Number(selector.dataset.slotHeight)): null,    
      slotWidth: selector.dataset.slotWidth? Math.round(Number(selector.dataset.slotWidth)): null
    }];
    
    // const main_loop = qty * occcupied_slot;
    const main_loop = qty;
    console.log("occcupied_slot dd",occcupied_slot,main_loop,qty);

         for (let mi = 0; mi < main_loop; mi++) {
          console.log("mi",mi)
          document.body.classList.remove("slot_full_open_popup");
          const allSlots = document.querySelectorAll(".meta-slots .slot:not([data-meta-handle])");    
          const empty_slot_count = allSlots.length;
          if(empty_slot_count < parseInt(occcupied_slot))
            {
              const emptySlotTotal = getEmptySlotTotal(selector); 
              console.log("emptySlotTotal_emptySlotTotal",emptySlotTotal)
              return; 
            }
              const data_occcupied = `occgid_${Date.now()}`;  
                    if(is_image_meta == "true"){      
                      if (!imgSrc) return;   
                      console.log("uploadImageFromURL"); 

                      const slot_number =  parseInt(input.getAttribute('data-slot'),10) || null;

                      if(document.body.classList.contains('template-scadas-es')){
                        canvas_groupid = uploadImageFromURLES(window.canvas, imgSrc, slotData, slot_number,occcupied_slot);
                      }else{
                        canvas_groupid = uploadImageFromURL(window.canvas, imgSrc, slotData, slot_number);
                      }
                    }
                    for (let i = 0; i < occcupied_slot; i++) {

                      const slotInputs = Array.from(document.querySelectorAll(".meta-slot-input")); 
                        const input = getNextEmptySlot(slotInputs);     
                        if(!input) return;
                          if(canvas_groupid){
                              input.setAttribute(`data-canvas-group-id` , canvas_groupid);   
                          }
                        input.setAttribute(`data-occcupied-slot-id` , data_occcupied);   
                        input.classList.add('active');
                      
                        input.checked = true;
                        input.value = variantId;

                        const slot = input.closest(".slot");

                        let ites_combine = false;

                        if(i > 0){
                            slot.classList.add("its-combine");
                            ites_combine = true;
                        }

                        slot.setAttribute("data-meta-handle", handle);

                        const titleEl = slot.querySelector(".slot-title");
                        const removeEl = slot.querySelector(".slot-controls")?.classList.remove("hidden");
                        const removeInfoBtn = slot.querySelector(".slot-pdp-info-button")?.classList.remove("hidden");
                        const select_msg = slot.querySelector(".select_third_product")?.classList.add("hidden");
                        if (titleEl) titleEl.textContent = (ites_combine ? window.fullslodtitle : productTitle) ;
                        const selected_title = slot.querySelector(".status_text_info")?.getAttribute("selecetd_title");
                        slot.querySelector(".status_text_info").innerHTML = selected_title;

                    } 

               if(canvas_groupid) select_canvo_main(canvas_groupid);
         }
  }




  if(document.body.classList.contains('template-scadas-rs')){

    function setupSlotRemoveEvents(This) {      
      const data_slot_no = parseInt(This.closest("[data-meta-slot]").getAttribute("data-meta-slot"));
        const slotRules = [
            { max: 7, value: "8" },
            { max: 11, value: "14" },
            { max: 13, value: "20" },
            { max: 19, value: "26" }
          ];
          const isMatched = slotRules.find(rule => {
            return Number(rule.value) === Number(data_slot_no);
          });
          
          console.log("isMatched",isMatched);
            const matchedValue = isMatched ? isMatched.value : null;                        
            if (isMatched) {                     
                const input_popup = document.querySelector(`[data-occupide-slot="${matchedValue}"]`);            
                input_popup?.closest(".popup_option").classList.remove("disabled");
              
                for (let i = data_slot_no; i <= data_slot_no + 5; i ++) {
                  This = document.querySelector(`[data-slot="${i}"]`);
                  if (This) {                    
                       if(This.closest(".slot")?.classList.contains('its-combine')) This.closest(".slot").classList.remove('its-combine');
                      
                        const slotInput = This.closest(".slot")?.querySelector(".meta-slot-input");                               
                          if (!slotInput && !slotInput.value) return true;
                        const parent_card = document.querySelector(`.main-tab-products-content .product-card.card-wrapper[data-variant-id="${slotInput.value}"]`) || null;                         
                    if (!parent_card) return true;
                        let main_product = parent_card?.querySelector("quantity-input .quantity__input");      
                        let int_value_qty = parseInt(main_product.value) || 0;
                        const data_input = parent_card?.querySelector(".variant-checkbox.cust_btn_select")

                        const handle_card = parent_card?.getAttribute("data-handle");                           
                          if (handle_card) {
                            let selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];                          
                            selectedProducts = selectedProducts.map(item => {
                              if (item.handle === handle_card) {
                                let updatedQty = parseInt(item.quantity) - 1;
                                return {...item,quantity: updatedQty};
                              }
                              return item;
                            })
                            .filter(item => item.quantity > 0);        
                            localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
                                     
                          }

                        const mina_class = This.closest("metawise-variant-selector") || null;
                        if(!mina_class) return true;            

                        const slotInput_select_attr = slotInput.getAttribute('data-occcupied-slot-id');
                        if(slotInput_select_attr) {
                          const all_inputs = document.querySelectorAll(`.meta-slot-input[data-occcupied-slot-id=${slotInput_select_attr}]`) || null;      
                          if(all_inputs.length > 1){
                            all_inputs.forEach(input => {
                              //  console.log("input_function",input);
                              if(input.closest(".slot")?.classList.contains('its-combine')) input.closest(".slot").classList.remove('its-combine');
                              if (typeof mina_class.clearSlot === "function") {
                               
                                mina_class.clearSlot(input);
                                input.classList.remove('active');
                              }
                            });
                          }
                        }else{
                              if (typeof mina_class.clearSlot === "function") {
                               
                              mina_class.clearSlot(slotInput);
                              slotInput.classList.remove('active');
                            }
                        }               
                        const emptySlotTotal = getEmptySlotTotal(data_input,int_value_qty);           
                  }
                }

                
              // const checkedInput = [document.querySelectorAll(".popup_rs .popup_option:not(.disabled) .is_checked")].find(input => !input.checked);
              // const allSelected = !!checkedInput;
              // if(allSelected) {   
              //   // disablePopupInputs(checkedInput[0]); 
              // }

            }else{
               if(This.closest(".slot")?.classList.contains('its-combine')) This.closest(".slot").classList.remove('its-combine');
        
                const slotInput = This.closest(".slot")?.querySelector(".meta-slot-input");          
                  if (!slotInput) return true;
                const parent_card = document.querySelector(`.main-tab-products-content .product-card.card-wrapper[data-variant-id="${slotInput.value}"]`) || null;        
                let main_product = parent_card?.querySelector("quantity-input .quantity__input");          
                console.log("main_product",main_product);
                let int_value_qty = parseInt(main_product.value) || 0;
                const data_input = parent_card?.querySelector(".variant-checkbox.cust_btn_select")
                const handle_card = parent_card?.getAttribute("data-handle");       
                  
                  if (handle_card) {
                    let selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
                    selectedProducts = selectedProducts.map(item => {
                      if (item.handle === handle_card) {
                        let updatedQty = parseInt(item.quantity) - 1;
                        return {...item,quantity: updatedQty};
                      }
                      return item;
                    })
                    .filter(item => item.quantity > 0); 
                    localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
                     console.log("selectedProducts",selectedProducts);         
                  }
                const mina_class = This.closest("metawise-variant-selector") || null;
                if(!mina_class) return true;            

                const slotInput_select_attr = slotInput.getAttribute('data-occcupied-slot-id');
                if(slotInput_select_attr) {
                  const all_inputs = document.querySelectorAll(`.meta-slot-input[data-occcupied-slot-id=${slotInput_select_attr}]`) || null;      
                  if(all_inputs.length > 1){
                    all_inputs.forEach(input => {
                      //  console.log("input_function",input);
                      if(input.closest(".slot")?.classList.contains('its-combine')) input.closest(".slot").classList.remove('its-combine');
                      if (typeof mina_class.clearSlot === "function") {
                         console.log("if clearslot");
                        mina_class.clearSlot(input);
                        input.classList.remove('active');
                      }
                    });
                  }
                }else{
                      if (typeof mina_class.clearSlot === "function") {
                         console.log("else clearslot");
                      mina_class.clearSlot(slotInput);
                      slotInput.classList.remove('active');
                    }
                }               
                const emptySlotTotal = getEmptySlotTotal(data_input,int_value_qty);           
            }


         
      }

  }else{    
    function setupSlotRemoveEvents(This) {     
        if(This.closest(".slot")?.classList.contains('its-combine')) This.closest(".slot").classList.remove('its-combine');
       
        const slotInput = This.closest(".slot")?.querySelector(".meta-slot-input");        
          if (!slotInput) return true;
    
        const parent_card = document.querySelector(`.main-tab-products-content .product-card.card-wrapper[data-variant-id="${slotInput.value}"]`) || null;        
        let main_product = parent_card?.querySelector("quantity-input .quantity__input");        
        let int_value_qty = parseInt(main_product?.value) || 0;
        const data_input = parent_card?.querySelector(".variant-checkbox.cust_btn_select")
        const handle_card = parent_card?.getAttribute("data-handle");           
          // if(int_value_qty != 0) {
          //   if(int_value_qty < 1){                    
          //     console.log("int_value_qty",int_value_qty);
          //   }else{
          //     console.log("int_value_qty else",int_value_qty);
          //     int_value_qty = int_value_qty - 1;          
    
          //   }
          //   // main_product.value = int_value_qty;
          // }else{
          //   console.log("inside the else")
          //   main_product.value = 0;        
          // }
    
          // if(int_value_qty > 0 ){ 
          //     int_value_qty = int_value_qty - 1;
          //      main_product.value = int_value_qty;
          //   }
          //    console.log("int_value_qty",int_value_qty);
            
    
          if (handle_card) {
            let selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
            selectedProducts = selectedProducts.map(item => {
              if (item.handle === handle_card) {
                let updatedQty = parseInt(item.quantity) - 1;
                return {...item,quantity: updatedQty};
              }
              return item;
            })
            .filter(item => item.quantity > 0); 
            localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
          }
        const mina_class = This.closest("metawise-variant-selector") || null;
        if(!mina_class) return true;            
    
        const slotInput_select_attr = slotInput.getAttribute('data-occcupied-slot-id');
        if(slotInput_select_attr) {
          const all_inputs = document.querySelectorAll(`.meta-slot-input[data-occcupied-slot-id=${slotInput_select_attr}]`) || null;      
          if(all_inputs.length > 1){
            all_inputs.forEach(input => {
              //  console.log("input_function",input);
              if(input.closest(".slot")?.classList.contains('its-combine')) input.closest(".slot").classList.remove('its-combine');
              if (typeof mina_class.clearSlot === "function") {
                mina_class.clearSlot(input);
                input.classList.remove('active');
              }
            });
          }
        }else{
              if (typeof mina_class.clearSlot === "function") {
              mina_class.clearSlot(slotInput);
              slotInput.classList.remove('active');
            }
        }     
        const emptySlotTotal = getEmptySlotTotal(data_input,int_value_qty); 
    }
  }



function getEmptySlotTotal(currentInput,int_value_qty = null){
  const slotInputs = Array.from(document.querySelectorAll(".meta-slot-input"));
  const count_fill_qty = slotInputs.filter(i => i.checked).length; 
  const parent = currentInput?.closest("metawise-variant-selector");
  if(!currentInput) return;
  const radios = parent?.querySelectorAll(".product-card .variant-radio");
  const labelText = currentInput?.dataset.tagText || "";     
    document.body.classList.add("slot_full_open_popup"); 
    const is_slot_fill = document.body.classList.contains("slot_full_open_popup");
    const totalQty = Array.from(radios)
      .filter(input => !input.value.includes(labelText))
      .reduce((sum, input) => {
        const card = input.closest(".product-card");
        const qty = parseInt(card?.querySelector(".quantity_product_card")?.value || 1,10);
        return sum + qty;
      }, 0);     

      const parent_is_rs = currentInput?.closest(".metawise-selected_rs");
      if(parent_is_rs){          
          if (count_fill_qty <= 7) {
            window.limit = 7;
          } else if (count_fill_qty <= 13) {
            window.limit = 13;
          } else if (count_fill_qty <= 18) {
            window.limit = 18;
          } else if (count_fill_qty <= 23) {
            window.limit = 23;
          } else{
            window.limit = 1;
          }               
      }
      if(!parent_is_rs && is_slot_fill){  
        // popup up open
        const mainDiv = currentInput.closest(".product-card-wrapper");
        if (!mainDiv) return;    
          const popupElement = mainDiv.querySelector('.popup_data_info');                      
          // if (popupElement) {
          //   mainDiv.querySelector(".card_popup_content")?.classList.add("popup-active");
          //   popupElement.style.display = 'block';
          //   document.body.classList.add('popup-active');
          // }            
          this.popDesc = popupElement.querySelector(".total_capacity");
          if(this.popDesc) this.popDesc.innerHTML = count_fill_qty;          
          const totalQtyinp = popupElement.querySelector(".current_capacity");          
          if(totalQtyinp) totalQtyinp.innerHTML = totalQty;                    
      }   
}

(() => {
  function loginFlowHandler() {
    const HASH = "#loginmsg";          
    if (window.location.hash === HASH) {    
      const wait = () => {
        const resultBtn = document.querySelector(".result_data_next_btn");
        if (resultBtn){
            return requestAnimationFrame(wait);            
        const result_block = document.querySelector(".show_selected_content");            
        document.body.classList.add("result_bloack_show");
          history.replaceState(null, "", window.location.pathname);
          resultBtn?.querySelector("a.customer_result_check").click();
        }else{
            history.replaceState(null, "", window.location.pathname);
          document.querySelector("a.customer_result_check")?.click();
        }
      };    
      wait();
    }
  }               
  loginFlowHandler();    
})();

async function selectedProductShow(handle) {
  const image_filds = document.querySelector('[data-slot-main-image]') || null;

  if (window.canvasfinalimagesrc) {

    if(image_filds) image_filds.value = window.canvasfinalimagesrc;
    localStorage.setItem("mainconfiimage", window.canvasfinalimagesrc);
      const wrapper = document.createElement("div");
      wrapper.className = "selected_product_show";

      wrapper.innerHTML = `
        <div class="image">
          <img src="${window.canvasfinalimagesrc}" 
              alt="product-image-canvas" 
              loading="lazy" />
        </div>
      `;          
      return wrapper;
    }
      try {
          const response = await fetch(`/products/${handle}?view=show_selected_product`);          
          const productHTML = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(productHTML, 'text/html');          
          const mainDivEl = doc.querySelector('.selected_product_show');        
          const imgSrc = mainDivEl.querySelector('img')?.src || null;          

            if(image_filds) image_filds.value = imgSrc;
            localStorage.setItem("mainconfiimage", imgSrc);

          
          if(mainDivEl){
            return mainDivEl;
          }else{
            return null;
          }
          return 
            // mainDiv: mainDivEl ? mainDivEl.outerHTML : '',     
      
        } catch (error) {
          console.error('Error fetching product info:', error);
          return null;
        }
}

async function progressbarimage(handle) {
  if(!handle) return; 
    const show_image_info = await selectedProductShow(image_handle);
      const main_progress_bar = show_image_info.querySelector("img");                    
      const progress_bar = document.querySelectorAll(".progressbar_image");
        progress_bar?.forEach(function(bar){
          const image_bar = bar.querySelector("img");          
          if(image_bar && main_progress_bar){
            image_bar.src = main_progress_bar.src;
          }    
        }); 

  
}

function updateMainObject(mainobjectc, filteabalobject) {

  filteabalobject.forEach(filterItem => {
    const metafield = mainobjectc.metafields.find(
      meta => meta.key === filterItem.key
    );

    if (metafield) {metafield.value = filterItem.value;}
  });

  return mainobjectc;
}

// sticky bar in progress the value
  function checkStepsHiddenDisplay(step_div) {
    const hiddenElements = document.querySelectorAll('.steps_hidden');
    const hiddenArray = Array.from(hiddenElements);
    const currentStep = step_div.closest('.steps_hidden');
    const currentIndex = hiddenArray.indexOf(currentStep);  
    const stepNoElement = currentStep.querySelector(".qus-numb");
    const step_no = Number(stepNoElement?.innerHTML?.trim());
    if (!step_no) return;
    const prevStep_no = currentIndex > 0 
      ? Number(hiddenArray[currentIndex - 1].querySelector(".qus-numb")?.innerHTML?.trim()) 
      : step_no -1;

    const progressBars = document.querySelectorAll('.step_wise_bar');

    progressBars.forEach((progress) => {
      const barFirst = Number(progress.dataset.barFirst) || 10;
      const barSecond = Number(progress.dataset.barSecond) || 10;
      const barThird = Number(progress.dataset.barThird) || 10;
      const barFour = Number(progress.dataset.barFour) || 10;
      const barFifth = Number(progress.dataset.barFifth) || 10;
      const barSixth = Number(progress.dataset.barSixth) || 10;
      const barSeventh = Number(progress.dataset.barSeventh) || 10;
      const barEighth = Number(progress.dataset.barEighth) || 10;      
      const total = Number(progress.dataset.totalStepCount) || 10;

      const first_bar = progress.querySelector(".first_bar");
      const second_bar = progress.querySelector(".bar_second");
      const third_bar = progress.querySelector(".bar_third");
      const four_bar = progress.querySelector(".bar_four");
      const fifth_bar = progress.querySelector(".bar_fifth");      
      const sixth_bar = progress.querySelector(".bar_sixth"); 
      const seventh_bar = progress.querySelector(".bar_seventh");      
      const eighth_bar = progress.querySelector(".bar_eighth");       

      const isStepOne = step_no === barFirst;      
      // const activeStepNo = currentStep.classList.contains("is_selected")? step_no: prevStep_no;
      const activeStepNo =  prevStep_no;

      // Determine multiplier
      let multiplier = 0;
      if (activeStepNo >= barEighth) multiplier = 8; 
      else if (activeStepNo >= barSeventh) multiplier = 7;
      else if (activeStepNo >= barSixth) multiplier = 6;
      else if (activeStepNo >= barFifth) multiplier = 5;
      else if (activeStepNo >= barFour) multiplier = 4;
      else if (activeStepNo >= barThird) multiplier = 3;
      else if (activeStepNo >= barSecond) multiplier = 2;
      else if (activeStepNo >= barFirst) multiplier = 1;  

      const multiplier_pro = multiplier > 0 ? multiplier -1 : multiplier;
      let progressValue = (100 / total) * multiplier_pro;
      let progressValue_curn = ((100 / total) * (multiplier));
      // if(multiplier == 1)  progressValue_curn = 0;
      if(progressValue_curn > 100)  progressValue_curn = 100;
      if(progressValue > 100)  progressValue = 100;

      progress.dataset.progress = progressValue;    
      // Set active states
      first_bar?.classList.toggle("active", multiplier >= 1);
      second_bar?.classList.toggle("active", multiplier >= 2);
      third_bar?.classList.toggle("active", multiplier >= 3);
      four_bar?.classList.toggle("active", multiplier >= 4);
      fifth_bar?.classList.toggle("active", multiplier >= 5);
      sixth_bar?.classList.toggle("active", multiplier >= 6);
      seventh_bar?.classList.toggle("active", multiplier >= 7);
      eighth_bar?.classList.toggle("active", multiplier >= 8);  
      // Update progress width
      const indicator = progress.querySelector('.progessbar_steps .indicator');
      if (indicator) {
        indicator.style.width = `${progressValue}%`;
      }

      // current stap green mark
      const indicator_curn = progress.querySelector('.progessbar_steps .indicator_cureant_stap');
        if (indicator_curn) {        
          indicator_curn.style.width = `${progressValue_curn}%`;
      }

    });

    setTimeout(scrollToActiveStep, 200);

  }

  // Observer callback
  function observeDisplayChanges() {
    const targets = document.querySelectorAll('.steps_hidden');

    //step wise progressbar
    const progressLinks = document.querySelectorAll(".progress-bar a");
    const steps = document.querySelectorAll(".steps_hidden");

    progressLinks.forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault();  
        const targetStep = parseInt(this.getAttribute("data-step-move"), 10);
        
        steps.forEach((step, index) => {   
          // console.log("index",index + 1,"targetStep",targetStep -1);
          if (index + 1 === targetStep -1) {        
            step.style.display = "block";
            // checkStepsHiddenDisplay(step);
          } else {      
            step.style.display = "none";
          }
        });

        // checkStepsHiddenDisplay(target);

        
        // progressLinks.forEach(a => a.classList.remove("active"));
        // this.classList.add("active");
      });
    });

    
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          (mutation.attributeName === 'style' || mutation.attributeName === 'class')
        ) {
          const target = mutation.target;
          const display = window.getComputedStyle(target).display;
          // Call function only if element is visible (change condition as needed)
          if (display !== 'none') {
            checkStepsHiddenDisplay(target);
          }
        }
      }
    });
    const config = { attributes: true, attributeFilter: ['style', 'class'] };
    targets.forEach(target => {
      observer.observe(target, config);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    observeDisplayChanges(); // Start observing after DOM is ready
  });

// sticky bar hide, show, click 
  function checkSticky() {
    // Get both sets of elements
    const targets1 = document.querySelectorAll('.circult_diagram');
    const targets2 = document.querySelectorAll('.selecetd_product_image');
    const targets3 = document.querySelectorAll(".pro-card-details");
    const targets4 = document.querySelectorAll(".show_progressbar_to_here");
    // const targets3 = document.querySelectorAll(".product-cards-wrapper");
      
    // const allTargets = [...targets1, ...targets2, ...targets3];
        const allTargets = [...targets1, ...targets2, ...targets3, ...targets4];
      
    // Find first visible element
    const target = allTargets.find(el => {
      return el && getComputedStyle(el).display !== 'none';
    });

    const bars = document.querySelectorAll('.product_step');

    bars.forEach(bar => {
      if (!target) {
        bar.classList.remove('sticky');
        bar.style.display = 'none';
        return;
      }

      const rect = target.getBoundingClientRect();
      if (rect.bottom <= 0) {
        bar.classList.add('sticky');
        bar.style.display = 'block';
      } else {
        bar.classList.remove('sticky');
        bar.style.display = 'none';
      }
    });
  }
  window.addEventListener('scroll', checkSticky);

function showLessmorePopup(btn) {
    const popup = btn.closest(".popup.popup_rs");
    const options = popup.querySelectorAll(".option.popup_option");
    let firstZeroFound = false;
    let hasZeroQty = false;

    options.forEach((option) => {
        const qtyInput = option.querySelector("quantity-input .quantity__input");
        const qty = parseInt(qtyInput?.value || 0);
        console.log("qty",qty,"qtyInput",qtyInput);

        if (qty == 0) {
           hasZeroQty = true;
          if (!firstZeroFound) {
            option.querySelector(".is_checked").click();
            option.classList.remove("hidden");
            firstZeroFound = true;
          }
        } else {
            // btn.classList.add("hidden");      
        }
    });
    // if (!hasZeroQty) {
    //     btn.classList.add("hidden");
    // }
}
